import {
    ICategoriaServicio,
    LOAD_CATEGORIAS_SERVICIOS_SUCCESS,
    ServicioAdicionalActionTypes, UPDATE_SERVICIO, UPDATE_SERVICIOS
} from "../types/servicioAdicionalType";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

function loadCategoriasSuccess(categorias: ICategoriaServicio[]): ServicioAdicionalActionTypes {
    return {
        type: LOAD_CATEGORIAS_SERVICIOS_SUCCESS,
        categorias
    }
}

export function updateServicio(servicioAdicional: ServicioAdicional): ServicioAdicionalActionTypes {
    return {
        type: UPDATE_SERVICIO,
        servicioAdicional
    }
}

export function updateServicios(serviciosAdicionales: ServicioAdicional[]): ServicioAdicionalActionTypes {
    return {
        type: UPDATE_SERVICIOS,
        serviciosAdicionales
    }
}

export function loadCategoriasServicios() {
    return function (dispatch) {
        return apiSource.obtener<ICategoriaServicio[]>("categoria-servicio-adicional/many")
            .then((categorias: ICategoriaServicio[]) => {

                categorias.length && categorias.forEach(c => c.expanded = true);
                dispatch(loadCategoriasSuccess(categorias))
            })
            .catch(error => {
               // throw error;
            })
    }
}
